import React from 'react';
import { Urls } from '../../../Helpers/Api';
import "./Directions.scss";
import DirectionForm from '../../../DirectionForm/DirectionForm.jsx';

export default class Directions extends React.Component {
    render(props) {
        let openHours = this.props.dealer.hours.map((sheduleTime, index) => (<span key={index} className="subtitle">{sheduleTime}</span>));

        return (<section className="directions info-panel-sections">
            <section className="info-panel-section">
                <h2>OUR ADDRESS</h2>
                <span className="subtitle">{this.props.dealer.address}</span>
            </section>
            <section className="info-panel-section">
                <h2>HOURS</h2>
                {openHours}
                <span className="dir-info">{this.props.dealer.remark}</span>
            </section>
            <section className="info-panel-section">
                <h2>GET DIRECTIONS</h2>
                <DirectionForm dealerAddress={this.props.dealer.address} />
            </section>
        </section>);
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Header/InfoPanel/Directions/Directions.jsx